export const environment = {
  production: false,
  envName: 'development',
  apiUrl: 'https://apigateway-dev-d0b81b703a80.herokuapp.com',
};
